export const plans = [
  'Basic',
  // 'Essential',
  'Advanced',
  'Professional',
  'Enterprise',
]

export const planKeys: Array<keyof PlanAvailability> = [
  'basic',
  // 'essential',
  'advanced',
  'professional',
  'enterprise',
]

export interface PlanAvailability {
  basic: boolean | number
  // essential: boolean | number
  advanced: boolean | number
  professional: boolean | number
  enterprise: boolean | number
}

export interface FeatureWithPlans {
  key: string
  plans: PlanAvailability
}

export interface PricingData {
  basic: Record<string, boolean | number>
  // essential: Record<string, boolean | number>
  advanced: Record<string, boolean | number>
  professional: Record<string, boolean | number>
  enterprise: Record<string, boolean | number>
}

export interface PricingDataArray {
  features: FeatureWithPlans[]
  labels: Record<string, string>
}
